<script setup lang="ts">
import { computed } from 'vue';
import TooltipIcon from './TooltipIcon.vue';

const props = defineProps<{
  label: string;
  modelValue: number | null;
  min?: number;
  step?: number;
  suffix?: string;
  prefix?: string;
  tooltip?: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void;
}>();

const valueString = computed({
  get: () => String(props.modelValue ?? 0),
  set: (val: string) => {
    const parsed = parseFloat(val);
    emit('update:modelValue', isNaN(parsed) ? 0 : parsed);
  }
});
</script>

<template>
  <label class="input-row">
    <div class="label">
      {{ label }}
      <TooltipIcon v-if="tooltip" :text="tooltip" />
    </div>
    <div class="input-wrapper">
      <span v-if="prefix" class="muted">{{ prefix }}</span>
      <input
        v-model="valueString"
        type="number"
        class="text-input"
        :min="min"
        :step="step ?? 1"
        :disabled="disabled"
      />
      <span v-if="suffix" class="muted">{{ suffix }}</span>
    </div>
  </label>
</template>

<style scoped>
.input-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.95rem;
}

.input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.4rem 0.55rem;
}

.text-input {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 1rem;
  outline: none;
}
</style>
